export default __webpack_public_path__ + "static/media/080_finish_good.hevc.81af358f.mp4";